import objectMap from '../utils/object-map';
import bpConfig from 'Config/breakpoints.json';

export default objectMap( bpConfig.breakpoints, val => parseInt(val,10) );
